<div class="klant-login-error canvas">
    <div class="klant-login-error__container">
        <div class="klant-login-error__illustration">
            <ap-illustration name="error"></ap-illustration>
        </div>
        <h1 class="tertiary" [id]="context">{{ 'klant.login.error.' + context + '.title' | apContent }}</h1>
        <div class="ap-display-block ap-margin-bottom-4">
            <ap-content [key]="'klant.login.error.' + context + '.text'"></ap-content>
        </div>
        @if (context !== 'no-cookies') {
            <ap-button type="button" (onClick)="doAction()">
                {{ 'klant.login.error.' + context + '.button' | apContent }}
            </ap-button>
        }
    </div>
</div>
